import { render, staticRenderFns } from "./Inventario.vue?vue&type=template&id=480c8faa&scoped=true"
import script from "./Inventario.vue?vue&type=script&lang=js"
export * from "./Inventario.vue?vue&type=script&lang=js"
import style0 from "./Inventario.vue?vue&type=style&index=0&id=480c8faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c8faa",
  null
  
)

export default component.exports